import { Tag } from '@superthread-com/api';
import { getCurrentInstance, computed } from 'vue';

export default function useGenerateTagsFromIds() {
  const _this = getCurrentInstance()?.proxy;
  if (!_this) return;

  const { getters } = _this.$store;

  const getTags = computed((): { [key: string]: Tag } => {
    return getters.getTags;
  });

  function generateTagsFromIds(ids: string[], projectId: string = '') {
    return ids
      .map((id) => getTags.value[id])
      .filter((tag) => tag && (!tag.project_id || tag.project_id === projectId));
  }

  return {
    generateTagsFromIds,
  };
}
